import React, { useState, useContext } from "react"

export const changeMenuTrigger = React.createContext({
  changeMenuFlag: false,
  setChangeMenuFlag: (value: boolean) => {},
})

export const useChangeMenuTrigger = () => {
  const [changeMenuFlag, setChangeMenuFlag] = useState(false)
  const _changeMenuTrigger = useContext(changeMenuTrigger)
  return { changeMenuFlag, setChangeMenuFlag, _changeMenuTrigger }
}
